import React from "react";

interface AddProps {
  width?: number;
  fill?: string;
  height?: number;
  onClick?: () => void;
}
const IconAdd: React.FC<AddProps> = ({ width, height }) => (
  <svg width="24" height="25.714" viewBox="0 0 24 25.714" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.286 14.817H1.714a1.66 1.66 0 0 1-1.221-.492A1.66 1.66 0 0 1 0 13.102q0-.727.494-1.221a1.66 1.66 0 0 1 1.22-.493h8.571V2.817q0-.727.492-1.221A1.66 1.66 0 0 1 12 1.102q.727 0 1.222.494.492.492.492 1.221v8.571h8.571q.727 0 1.222.494.492.492.492 1.221 0 .727-.492 1.222a1.66 1.66 0 0 1-1.222.492h-8.571v8.571q0 .727-.492 1.222a1.66 1.66 0 0 1-1.222.492 1.66 1.66 0 0 1-1.222-.492 1.66 1.66 0 0 1-.492-1.222z"
      fill="#1C1B1F"
    />
  </svg>
);
export default IconAdd;
